<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">
          <router-link to="/">
            <b-icon icon="chevron-left"></b-icon>Čakalna lista
          </router-link>
        </li>
      </ol>
    </nav>
    <span v-show="loading" class="spinner-border spinner-border-xl"></span>
    <div v-show="!loading" class="card card-fluid">
      <div class="form-group">
        <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
      </div>
      <div class="card-header">
        <div class="header-text float-left">{{dokumentTipKljuc}} - ID {{dokumentId}}</div>
        <div class="icons float-right">
          <b-button v-b-modal.modalComments>
            <b-icon icon="chat-left" aria-hidden="true"></b-icon>
          </b-button>
          <b-button v-b-modal.modalAttachments>
            <b-icon icon="paperclip" aria-hidden="true"></b-icon>
          </b-button>
        </div>
      </div>
      <div class="card-body">
          <dl v-for="atribut in atributList"
              :key="atribut.dokumentAtributId"
              class="d-flex justify-content-between">
              <dt class="text-left">
                  <span class="mr-2">{{ atribut.kljuc }}</span>
              </dt>
              <dd class="text-right mb-0">{{ formatJsonValue(atribut) }}</dd>
          </dl>
          <div v-show="showPotrjevalciSection" class="header-text text-left" style="font-weight: bold;">Potrjevalci na nivoju {{ nivo }}:</div>
          <ul v-for="user in forwardPotrjevalci"
              :key="user.uporabnikId"
              class="d-flex justify-content-between">
              <li class="text-left">
                  <span class="mr-2">{{ getUporabnikIme(user) }}</span>
              </li>
          </ul>
      </div>
      <footer class="card-footer">
        <div class="card-footer-content">
          <div class="row justify-content-center" v-show="!loading && isValid">
            <b-button @click="approve" pill variant="success">
              <b-icon icon="check-circle" aria-hidden="true"></b-icon>Potrdi
            </b-button>
            <b-button @click="deny" pill variant="danger">
              <b-icon icon="x-circle" aria-hidden="true"></b-icon>Zavrni
            </b-button>
          </div>
          <div class="row justify-content-center">
            <b-button @click="askForComment" pill variant="info">
              <b-icon icon="chat-left" aria-hidden="true"></b-icon>Mnenje
            </b-button>
            <b-button @click="forward" pill variant="warning" v-show="!loading && isValid">
              <b-icon icon="skip-forward" aria-hidden="true"></b-icon>Posreduj
            </b-button>
          </div>
        </div>
      </footer>
      <div class="page-footer"></div>
    </div>
    <kendo-dialog
      ref="dialogReject"
      :modal="true"
      width="80%"
      title="Zavrnitev dokumenta"
      :visible="false"
      :closable="false"
    >
      <textarea
        v-model="denyComment"
        type="text"
        class="form-control"
        placeholder="Razlog zavrnitve"
      ></textarea>
      <kendo-dialog-action text="Prekliči" :action="clearForms"></kendo-dialog-action>
      <kendo-dialog-action text="Zavrni" :action="denySubmit" :primary="true"></kendo-dialog-action>
    </kendo-dialog>
    <kendo-dialog
      ref="dialogComment"
      :modal="true"
      width="80%"
      title="Zahteva za komentar"
      :visible="false"
      :closable="false"
    >
      <div class="form-group">
        <label>Komentar</label>
        <textarea v-model="commentKomentar" type="text" class="form-control"></textarea>
      </div>
      <div class="form-group">
        <label>Dodeljen uporabnik</label>
        <kendo-dropdownlist
          v-model="commentDodeljenUporabnik"
          ref="dropdownCommentUser"
          :filter="'contains'"
          @filterchange="filterChange"
          :data-text-field="'text'"
          :data-value-field="'value'"
          :data-source="uporabnikList"
          style="width: 100%;"
        ></kendo-dropdownlist>
      </div>
      <kendo-dialog-action text="Prekliči" :action="clearForms"></kendo-dialog-action>
      <kendo-dialog-action text="Pošlji" :action="commentSubmit" :primary="true"></kendo-dialog-action>
    </kendo-dialog>
    <kendo-dialog
      ref="dialogForward"
      :modal="true"
      width="80%"
      title="Posredovanje dokumenta"
      :visible="false"
      :closable="false"
    >
      <div class="form-group">
        <label>Potrjevalci</label>
        <kendo-multiselect
          v-model="forwardPotrjevalci"
          :data-source="uporabnikList"
          :data-text-field="'text'"
          :data-value-field="'value'"
          :label="'Potrjevalci'"
          style="width: 100%"
        ></kendo-multiselect>
      </div>

      <kendo-dialog-action text="Prekliči" :action="clearForms"></kendo-dialog-action>
      <kendo-dialog-action text="Posreduj" :action="forwardSubmit" :primary="true"></kendo-dialog-action>
    </kendo-dialog>
    <b-modal modal-class="comment-modal" id="modalComments" title="Komentarji" hide-footer>
      <CommentPage :dokumentId="dokumentId"></CommentPage>
    </b-modal>
    <b-modal modal-class="attachment-modal" id="modalAttachments" title="Priloge" hide-footer>
      <AttachmentPage :dokumentId="dokumentId"></AttachmentPage>
    </b-modal>
  </div>
</template>

<script>
    import DokumentService from "../services/dokument.service";
    import UporabnikService from "../services/uporabnik.service";
    import SifrantService from "../services/sifrant.service";
    import moment from "moment";

    import CommentPage from "@/components/CommentPage.vue";
    import AttachmentPage from "@/components/AttachmentPage.vue";

    export default {
        name: "DocumentPage",
        components: {
            CommentPage,
            AttachmentPage,
        },
        props: {
            dokumentId: String,
        },
        data() {
            return {
                dokument: null,
                message: "",
                uporabnikList: [],
                sifrantList: [],
                partnerList: [],
                forwardPotrjevalci: [],
                nivo: 0,
                commentKomentar: "",
                commentDodeljenUporabnik: "",
                denyComment: "",
                loading: false,
                isValid: true
            };
        },
        computed: {
            dokumentTipKljuc() {
                if (this.dokument) {
                    return this.dokument.dokument.dokumentTipSifra;
                } else return "";
            },
            atributList() {
                if (this.dokument) return this.dokument.atributList;
                else return [];
            },
            showPotrjevalciSection() {
                return this.forwardPotrjevalci.length > 0
            }
        },
        methods: {
            getDokument(dokumentId) {
                this.loading = true;
                DokumentService.getDokument(dokumentId).then(
                    (response) => {
                        this.dokument = response.data;
                        if (this.dokument.dokument.dokumentStatusId > 5 || this.dokument.dokument.dokumentStatusId < 3) {
                            this.isValid = false
                            this.loading = false
                            return;
                        }
                        this.forwardPotrjevalci = this.dokument.dokument.potrjevalecList.filter(i => i.jeAktiven == true).map(
                            (i) => i.uporabnikId.toString()
                        );
                        if (!this.forwardPotrjevalci.includes(this.$store.state.auth.user.user.uporabnikId.toString())) {
                            this.loading = false
                            this.isValid = false
                        }
                        this.nivo = this.dokument.dokument.potrjevalecList.filter(i => i.jeAktiven == true)[0].nivo
                        this.loading = false;
                    },
                    (error) => {
                        this.message = error.data.split("\n")[0];
                        this.loading = false;
                    }
                );
            },
            getUporabnikList() {
                UporabnikService.getUporabnikList().then(
                    (response) => (this.uporabnikList = response.data),
                    (error) => {
                        this.message = error.data.split("\n")[0];
                    }
                );
            },
            getSifrantList() {
                SifrantService.getSifrantList().then(
                    (response) => (this.sifrantList = response.data),
                    (error) => {
                        this.message = error.data.split("\n")[0];
                    }
                );
            },
            getPartnerList() {
                SifrantService.getPartnerList().then(
                    (response) => (this.partnerList = response.data),
                    (error) => {
                        this.message = error.data.split("\n")[0];
                    }
                );
            },
            formatJsonValue(atribut) {
                if (
                    this.dokument.dokument[atribut.polje.toLowerCase()] == null &&
                    atribut.polje !== "SifrantPartnerId"
                )
                    return "";
                switch (atribut.dokumentAtributTipSifra) {
                    case "TEXT":
                        return this.dokument.dokument[atribut.polje.toLowerCase()];
                    case "DATETIME":
                        return moment(
                            this.dokument.dokument[atribut.polje.toLowerCase()]
                        ).format(atribut.formatRaw.toUpperCase());
                    case "TIME":
                        let timeObject = this.dokument.dokument[atribut.polje.toLowerCase()]
                            .value;
                        if (timeObject)
                            return moment({
                                hour: timeObject.hours,
                                minute: timeObject.minutes,
                                seconds: timeObject.seconds,
                            }).format(atribut.formatRaw);
                        else return "";
                    case "DECIMAL":
                        kendo.culture("sl-SI");
                        return kendo.toString(
                            this.dokument.dokument[atribut.polje.toLowerCase()],
                            atribut.formatRaw
                        );
                    case "BOOLEAN":
                        if (this.dokument.dokument[atribut.polje.toLowerCase()] == true)
                            return "DA";
                        else return "NE";
                    case "SELECT":
                        let sifrantId = parseInt(
                            this.dokument.dokument[atribut.polje.toLowerCase()]
                        );
                        return this.sifrantList.filter((i) => i.sifrantId == sifrantId)[0]
                            .sifra;
                    case "PARTNER":
                        let sifrantIdStr = this.dokument.dokument["sifrantPartnerId"];
                        if (sifrantIdStr == null || sifrantIdStr == "") return "";

                        let partnerId = parseInt(sifrantIdStr);
                        let partnerValue = this.partnerList.filter(
                            (i) => i.sifrantPartnerId == partnerId
                        )[0];
                        if (partnerValue != null)
                            return partnerValue.ime;
                        return "";
                    case "PERSON":
                        let userId = this.dokument.dokument[
                            atribut.polje.toLowerCase()
                        ].toString();
                        return this.uporabnikList.filter((i) => i.value == userId)[0].text;
                    default:
                        return "";
                }
            },
            approve() {
                DokumentService.updateDokumentApprove(
                    this.dokument.dokument.dokumentId
                ).then(
                    (data) => {
                        if (data.data && data.data != "OK") {
                            alert(data.data);
                        }
                        this.redirectToNextDocument();
                    },
                    (error) => {
                        this.message = error.data.split("\n")[0];
                    }
                );
            },
            deny(data) {
                this.$refs.dialogReject.kendoWidget().open();
            },
            forward() {
                this.$refs.dialogForward.kendoWidget().open();
            },
            askForComment() {
                this.$refs.dialogComment.kendoWidget().open();
            },
            denySubmit() {
                if (!this.denyComment) return false;

                DokumentService.updateDokumentDeny(
                    this.dokument.dokument.dokumentId,
                    this.denyComment
                ).then(
                    (data) => {
                        if (data.data && data.data != "OK") {
                            alert(data.data);
                        }
                        this.redirectToNextDocument()
                    },
                    (error) => {
                        this.message = error.data.split("\n")[0];
                    }
                );
            },
            forwardSubmit() {
                if (this.forwardPotrjevalci.length == 0) return false;
                DokumentService.updateDokumentForward(
                    this.dokument.dokument.dokumentId,
                    this.forwardPotrjevalci.map((i) => parseInt(i)),
                    this.nivo
                ).then(
                    () => {
                        this.redirectToNextDocument()
                    },
                    (error) => {
                        this.message = error.data.split("\n")[0];
                    }
                );
            },
            commentSubmit() {
                if (!this.commentKomentar || !this.commentDodeljenUporabnik) return false;
                DokumentService.updateDokumentComment(
                    this.dokument.dokument.dokumentId,
                    this.commentKomentar,
                    parseInt(this.commentDodeljenUporabnik)
                ).then(
                    () => {
                        this.redirectToNextDocument();
                    },
                    (error) => {
                        this.message = error.data.split("\n")[0];
                    }
                );
            },
            clearForms() {
                this.commentKomentar = null;
                this.commentDodeljenUporabnik = null;
                this.forwardPotrjevalci = this.forwardPotrjevalci = this.dokument.dokument.potrjevalecList.map(
                    (i) => i.toString()
                );
                this.denyComment = null;
            },
            async loadSifrantData() {
                this.getUporabnikList();
                this.getSifrantList();
                this.getPartnerList();
            },
            filterChange(event) {
                return;
            }, 
            getUporabnikIme(uporabnikId) {
                return this.uporabnikList.filter(i => i.value == uporabnikId)[0].text;
            }, 
            redirectToNextDocument() {
                DokumentService.getNextDokument(this.dokument.dokument.dokumentId, this.dokument.dokument.dokumentTipId).then(
                    (response) => {

                        if (response.data == null) {
                            this.$router.push("/");
                        }
                        else {
                            this.$router.push("/document/" + response.data.dokumentId);
                            this.getDokument(response.data.dokumentId);
                        }
                    },
                    (error) => {
                        this.message = error.data.split("\n")[0];
                    }
                );
            }
        },
        async created() {
            await this.loadSifrantData();
            this.getDokument(this.dokumentId);
        },
    };
</script>

<style scoped>
.btn {
  width: 40%;
  margin: 2% 5%;
}



.card-header {
  padding-top: 0;
}

.comment-modal {
  max-width: 100% !important;
  margin: 0 !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 100vh !important;
  display: flex !important;
  position: fixed !important;
}

.all-done {
    color: #c3949f;
    padding-top: 20%;
}

    #btnBack {
        margin-top: 1rem;
        border-color: #c3949f;
        background-color: #c3949f;
    }
</style>
